import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import PageHero from './components/PageHero';
import IntroSection from './components/IntroSection';
import ServiceTabs from './components/ServiceTabs';
import AreaSection from './components/AreaSection';
import FlowSection from './components/FlowSection';
import FAQSection from './components/FAQSection';

export default function ServicePage() {
  useSEO({
    title: '訪問介護サービス内容 | 逗子市まごころヘルパー - 身体介護・生活援助',
    description: '逗子市のまごころヘルパーが提供する訪問介護サービスの詳細。身体介護(食事・入浴・排泄介助)、生活援助(掃除・洗濯・買い物)、服薬確認など、ご利用者様のニーズに合わせた質の高い訪問介護サービスをご提供します。サービス利用の流れ、対応エリア、よくある質問もご紹介。',
    keywords: '訪問介護,サービス内容,身体介護,生活援助,逗子市,まごころヘルパー,介護保険,服薬確認',
    path: '/service',
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "訪問介護サービス",
      "serviceType": "訪問介護",
      "provider": {
        "@type": "LocalBusiness",
        "name": "まごころヘルパー",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "逗子5-7-17 コーポ高木101",
          "addressLocality": "逗子市",
          "addressRegion": "神奈川県",
          "postalCode": "249-0006",
          "addressCountry": "JP"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "逗子市"
      },
      "description": "身体介護、生活援助、服薬確認など、ご利用者様のニーズに合わせた質の高い訪問介護サービス",
      "url": `${import.meta.env.VITE_SITE_URL}/service`
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.observe-animation').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PageHero />
      <IntroSection />
      <ServiceTabs />
      <AreaSection />
      <FlowSection />
      <FAQSection />
    </div>
  );
}
